import React from 'react'
import { Link } from 'react-router-dom';

const data = {
    subHead: 'GET CLOSER TO ACTION',
    heading: "Combat Driver Fatigue with DSM Cameras for Safer, Smarter Fleets!",
    emp: '',
    img: '/images/products/cabin-vision2.webp',
    logo: '/images/solution-logo/cabin-vision-white.svg',
    link: "/insights/blog/cabin-vision-dsm-cameras-redefining-fleet-safety-and-performance",
};
const FeaturedContent = () => {
  return (
    <>
    <div className='container featured-content'
                style={{
                    backgroundImage: `url(${data?.img})`,
                    backgroundSize: "cover",
                    height: "100vh",
                    width: "100vw"
                }}
            >
                <div className="row py-5">
                    <div className="col col-12 col-lg-5 ms-lg-5">
                        <div className='logo'>
                            <img src={data?.logo} alt="" className='w-100' />
                        </div>
                        <p className='my-5 fw-bold fs-6 text-light'>
                            {data?.subHead || "SEE IT IN ACTION"}
                        </p>
                        <div className="mb-4">
                            <h1 className="content-scale text-white">
                                {data?.heading || "Precision Door Service uses dashcams to help protect their"}{" "}
                                {/* <i className='text-accent text-lora'>{data?.emp || "business & coach drivers."}</i> */}
                            </h1>
                        </div>
                        <Link to={data?.link || "#"} className='btn btn-light btn-lg fw-bold rounded-5'>Read story</Link>
                    </div>
                </div>
            </div>
    </>
  )
}

export default FeaturedContent